import { SwitchRoot } from "./SwitchRoot";

export const Switch = {
  Root: SwitchRoot,
};
